import React, { memo } from "react";
import { makeStyles } from "@material-ui/core";

import { RequestIcon } from "../../../icons";
import { Text, View } from "../../../Base";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    position: "relative",
    display: "flex",
    alignItems: "flex-end",
    marginTop: typography.pxToRem(5),
    marginBottom: typography.pxToRem(9),
  },
  value: {
    position: "absolute",
    background: "white",
    width: typography.pxToRem(14),
    height: typography.pxToRem(14),
    borderRadius: typography.pxToRem(7),
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    fontSize: "7px",
    fontWeight: "bold",
    bottom: typography.pxToRem(15),
    left: typography.pxToRem(15),
  },
  icon: {
    width: typography.pxToRem(24),
    height: typography.pxToRem(24),
  },
}));

const Request = ({ value }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Text className={styles.value} data-testid="route-icon-request-value">
        {value}
      </Text>
      <RequestIcon data-testid="route-icon-request" className={styles.icon} />
    </View>
  );
};

export default memo(Request);
